import { render, staticRenderFns } from "./AspectRatioConfig.vue?vue&type=template&id=4402c00e&scoped=true"
import script from "./AspectRatioConfig.vue?vue&type=script&lang=js"
export * from "./AspectRatioConfig.vue?vue&type=script&lang=js"
import style0 from "./AspectRatioConfig.vue?vue&type=style&index=0&id=4402c00e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4402c00e",
  null
  
)

export default component.exports